module.exports = __webpack_public_path__ + "img/梅花初级大师@2x.06395480.png";